export default __webpack_public_path__ + "static/media/SIFA_EPILOGFIN3.15515bf4.mp3";